var _jsxFileName = "/src/main/react/src/main/app/components/common/SortsAndFilters.js";
import { Q_STRING, SORT_FIELD } from "../domain/constants";
import { Grid, Typography, Select, MenuItem, FormControl, FormGroup, FormControlLabel, Checkbox, Input } from "@material-ui/core";
import React, { Fragment } from 'react';
import { changeSearchValue, listToUrlString } from "../../util/QueryStringUtil";
export default function SortsAndFilters(self, classes) {
  /**
   * Handles changes to the sortField value by listening to the Select dropdown
   *
   * Have to forceUpdate because of the way setState works: https://reactjs.org/docs/react-component.html#setstate
   */
  let handleSortFieldChange = event => {
    self.state.sortField = event.target.value;
    changeSearchValue(Q_STRING.SORT_FIELD, event.target.value, self.props);
    self.reset();
    self.forceUpdate();
  };

  /**
   * Handles changes to the sortDescending field by listening to the value of the Checkbox
   *
   * Have to forceUpdate because of the way setState works: https://reactjs.org/docs/react-component.html#setstate
   */
  let handleCheckChange = event => {
    self.state.sortDescending = event.target.checked;
    changeSearchValue(Q_STRING.SORT_DESCENDING, event.target.checked, self.props);
    self.reset();
    self.forceUpdate();
  };

  /**
   * Handles generic field changes
   *
   * Have to forceUpdate because of the way setState works: https://reactjs.org/docs/react-component.html#setstate
   */
  let handleChange = name => event => {
    let value = event.target.value;
    self.state[name] = value;
    let qStringParamName = null;
    if ('selectedFilters' === name) {
      qStringParamName = Q_STRING.FILTERS;
    }
    if (qStringParamName != null) {
      // selectedFilters comes out in an Array
      if (Array.isArray(value)) {
        value = listToUrlString(value);
      }
      changeSearchValue(qStringParamName, value, self.props);
    }
    self.reset();
    self.forceUpdate();
  };
  return /*#__PURE__*/React.createElement(Fragment, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    direction: 'row',
    alignContent: 'center',
    alignItems: 'center',
    justify: 'center',
    wrap: 'nowrap',
    spacing: 0,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    md: 8,
    item: true,
    container: true,
    direction: 'column',
    alignContent: 'center',
    alignItems: 'center',
    justify: 'center',
    wrap: 'nowrap',
    spacing: 0,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    direction: 'row',
    alignContent: 'center',
    alignItems: 'center',
    justify: 'center',
    wrap: 'nowrap',
    spacing: 1,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 74,
      columnNumber: 21
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 25
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 29
    }
  }, "Sort Field:")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 79,
      columnNumber: 25
    }
  }, /*#__PURE__*/React.createElement(Select, {
    value: self.state.sortField,
    onChange: handleSortFieldChange,
    displayEmpty: true,
    variant: "outlined",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 80,
      columnNumber: 29
    }
  }, self.state.allSortFields != null && self.state.allSortFields !== [] && self.state.allSortFields.map(sortField => /*#__PURE__*/React.createElement(MenuItem, {
    value: sortField,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 83,
      columnNumber: 37
    }
  }, sortField)), self.state.allSortFields == null || self.state.allSortFields === [] && /*#__PURE__*/React.createElement(Fragment, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 86,
      columnNumber: 33
    }
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: SORT_FIELD.title,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 87,
      columnNumber: 37
    }
  }, "Title"), /*#__PURE__*/React.createElement(MenuItem, {
    value: SORT_FIELD.expirationDate,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 88,
      columnNumber: 37
    }
  }, "Expiration Date"), /*#__PURE__*/React.createElement(MenuItem, {
    value: SORT_FIELD.availableDate,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 37
    }
  }, "Available Date")))))), /*#__PURE__*/React.createElement(Grid, {
    md: 8,
    item: true,
    container: true,
    direction: 'column',
    alignContent: 'center',
    alignItems: 'center',
    justify: 'center',
    wrap: 'nowrap',
    spacing: 1,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 96,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    direction: 'row',
    alignContent: 'center',
    alignItems: 'center',
    justify: 'center',
    wrap: 'nowrap',
    spacing: 0,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 98,
      columnNumber: 21
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 100,
      columnNumber: 25
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 101,
      columnNumber: 29
    }
  }, "Filters:")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 103,
      columnNumber: 25
    }
  }, /*#__PURE__*/React.createElement(FormControl, {
    className: classes.formControl,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 104,
      columnNumber: 29
    }
  }, /*#__PURE__*/React.createElement(Select, {
    id: "program-type-select",
    multiple: true,
    value: self.state.selectedFilters,
    onChange: handleChange('selectedFilters'),
    input: /*#__PURE__*/React.createElement(Input, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 107,
        columnNumber: 87
      }
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 105,
      columnNumber: 33
    }
  }, Object.keys(self.state.allFilters).sort().map(type => /*#__PURE__*/React.createElement(MenuItem, {
    value: self.state.allFilters[type],
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 109,
      columnNumber: 41
    }
  }, self.state.allFilters[type]))))))), /*#__PURE__*/React.createElement(Grid, {
    md: 8,
    item: true,
    container: true,
    direction: 'column',
    alignContent: 'center',
    alignItems: 'center',
    justify: 'center',
    wrap: 'nowrap',
    spacing: 1,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 117,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 119,
      columnNumber: 21
    }
  }, /*#__PURE__*/React.createElement(FormGroup, {
    row: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 120,
      columnNumber: 25
    }
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: self.state.sortDescending,
      onChange: handleCheckChange,
      value: self.state.sortDescending,
      color: 'primary',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 123,
        columnNumber: 37
      }
    }),
    label: 'Sort Descending',
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 121,
      columnNumber: 29
    }
  }))))));
}